module.exports = __webpack_public_path__ + "static/media/door01.27d32777.png";